import { InvoiceTypeOfStreet } from '../invoices/invoices.enums';
import { TaxAssessmentRegime } from './Settings.enums';

export const TYPE_OF_STREETS_OPTIONS = [
  {
    value: InvoiceTypeOfStreet.ALAMEDA,
    label: 'Alameda',
  },
  {
    value: InvoiceTypeOfStreet.AVENIDA,
    label: 'Avenida',
  },
  {
    value: InvoiceTypeOfStreet.CHACARA,
    label: 'Chácara',
  },
  {
    value: InvoiceTypeOfStreet.COLONIA,
    label: 'Colônia',
  },
  {
    value: InvoiceTypeOfStreet.CONDOMINIO,
    label: 'Condomínio',
  },
  {
    value: InvoiceTypeOfStreet.EQNP,
    label: 'EQNP',
  },
  {
    value: InvoiceTypeOfStreet.ESTANCIA,
    label: 'Estância',
  },
  {
    value: InvoiceTypeOfStreet.ESTRADA,
    label: 'Estrada',
  },
  {
    value: InvoiceTypeOfStreet.FAZENDA,
    label: 'Fazenda',
  },
  {
    value: InvoiceTypeOfStreet.PRACA,
    label: 'Praça',
  },
  {
    value: InvoiceTypeOfStreet.PROLONGAMENTO,
    label: 'Prolongamento',
  },
  {
    value: InvoiceTypeOfStreet.RODOVIA,
    label: 'Rodovia',
  },
  {
    value: InvoiceTypeOfStreet.RUA,
    label: 'Rua',
  },
  {
    value: InvoiceTypeOfStreet.SITIO,
    label: 'Sítio',
  },
  {
    value: InvoiceTypeOfStreet.TRAVESSA,
    label: 'Travessa',
  },
  {
    value: InvoiceTypeOfStreet.VICINAL,
    label: 'Vicinal',
  },
];

export const TaxAssessmentOptions = [
  {
    value: TaxAssessmentRegime.ByTheSimplesNational,
    label: 'Tributos federais e municipal pelo SN',
  },
  {
    value: TaxAssessmentRegime.ByTheSimplesNationalIssqnOnTheOutside,
    label:
      'Tributos federais pelo SN e ISSQN por fora do SN conforme respectiva legislação municipal do tributo',
  },
  {
    value: TaxAssessmentRegime.SimplesNationalOnTheOutside,
    label:
      'Tributos federais e municipal por fora do SN conforme respectivas legilações federal e municipal de cada tributo',
  },
];
